import { render, staticRenderFns } from "./BookmarkList.vue?vue&type=template&id=711eea46"
import script from "./BookmarkList.vue?vue&type=script&lang=js"
export * from "./BookmarkList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports